import { render, staticRenderFns } from "./modalPointLoad.vue?vue&type=template&id=2a3c0231&scoped=true"
import script from "./modalPointLoad.vue?vue&type=script&lang=js"
export * from "./modalPointLoad.vue?vue&type=script&lang=js"
import style0 from "./modalPointLoad.vue?vue&type=style&index=0&id=2a3c0231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c0231",
  null
  
)

export default component.exports